export const splitSettledPromises = (promises) => promises.reduce((memo, curr) => ({
    fulfilled: [...memo.fulfilled, ...(curr.status === 'fulfilled' && !!curr.value ? [curr.value] : [])],
    rejected: [
        ...memo.rejected,
        ...(curr.status === 'rejected' ? [curr.reason] : !curr.value ? [''] : []),
    ],
}), {
    fulfilled: [],
    rejected: [],
});
